export default { options: { label: 'Other Standing Multiple' } }
